import { Component, OnInit, ViewChild } from '@angular/core';
import { AddAdditionalWorkJobComponent } from './add-additional-work-job/add-additional-work-job.component';
import { WOConfirmationComponent } from './wo-confirmation/wo-confirmation.component';

const DWOTabs: { id: number, label: string, route: string }[] = [
  { id: 1, label: 'lblAddJob', route: 'addadditionalWork' },
  { id: 2, label: 'lblWOConfirmation', route: 'WOconfirmation' }
]
@Component({
  selector: 'app-appointment-additional-work',
  templateUrl: './appointment-additional-work.component.html',
  styleUrls: ['./appointment-additional-work.component.css']
})


export class AppointmentAdditionalWorkComponent implements OnInit {
  tabs: { id: number, label: string, route: string }[] = DWOTabs;
  selectedTabs:number=1;
  @ViewChild(AddAdditionalWorkJobComponent) childAddAdditionalWorkJobComponent: AddAdditionalWorkJobComponent;
  @ViewChild(WOConfirmationComponent) childWOConfirmationComponent: WOConfirmationComponent;
  constructor() {
     // This is intentional
   }

  ngOnInit(): void {
    if (this.selectedTabs == 1) {
      this.childAddAdditionalWorkJobComponent?.ngOnInit();
    }
    else if (this.selectedTabs == 2) {
      this.childWOConfirmationComponent?.ngOnInit();
    }
  }
}
